module.exports = __webpack_public_path__ + "img/viewProject_locked.c5e7f58c.svg";